import { React, Component } from "react";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import { connect } from "react-redux";
import ClassGroupComponent from "../../ClassesGroups/CreateClass/ClassGroupComponent";
import { getClassDetails, getClasses, getMyGroups } from "../../../redux/actions/classes";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import { getAllAssignments } from "../../../redux/actions/assignment";
import { getAllQuizzes } from "../../../redux/actions/quiz";
import { getAllCourses, clearCourses } from "../../../redux/actions/courses"

class Class extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      activeSection: "Post",
      subjectName: "",
      showCareerModal: false,
      showShareModal: false,
      showCourseModal: false,
      samplePosts: [
        {
          id: -1,
          name: "Himani",
          follower: "234",
          timestamp: "2 hrs",
          likes: "38",
          comments: null,
          profilePic: "/Image/Classes/himani_dp.jpg",
          likedPost: null,
          message: t("samplePosts.onlineLearningHelpStudents"),
          photoUrl: "/Image/Classes/classPost1.png",
          share_link: "2342",
        },
        {
          id: 0,
          name: "Harsh",
          follower: "853",
          likes: "47",
          comments: null,
          profilePic: "/Image/Classes/shivam_dp.jpg",
          likedPost: null,
          message: t("samplePosts.onlineEnvironment"),
          photoUrl: "/Image/Classes/classPost2.png",
          share_link: "8534",
        },
      ],
    };
  }
  getActiveClassDetails = (subjectId) => {
    let { history } = this.props;
    console.log('SUBJECT ID', subjectId)
    history.push({
      pathname: `/class/${subjectId}`,
      state: { subjectId: subjectId },
    });
    // this.props.getClasses();
    this.props.getMyGroups()
    this.props.getClassDetails(subjectId).then(() => {
      this.setState({ subjectId: this.props.subjectId });
      this.setState({ subjectName: this.props.subjectName });
    });
    this.props.getAllAssignments(subjectId, window.location?.pathname?.split('/')[1]);
    this.props.getAllQuizzes(subjectId, window.location?.pathname?.split('/')[1]);
    // this.props.clearCourses().then(()=>this.props.getAllCourses(subjectId, null, null, null, true));
  };
  componentDidMount = () => {

    this.props.getMyGroups()
    const subjectId = this.props.history.location.pathname.split("/")[2] || "";
    this.getActiveClassDetails(subjectId);
  };
  render() {
    return (
      <ClassGroupComponent
        subjectName={this.state.subjectName}
        class_id={this.props.history.location.pathname.split("/")[2]}
        subjectCode={this.props.subjectCode}
        routeType={this.props.routeType}
        imageCover={this.props.imageCover}
        toggleChatList={this.props.toggleChatList}
        subject={this.props.subject}
        // numOfPosts={this.props.numOfPosts}
        grade={this.props.grade}
        isChatListOpen={this.props.isChatListOpen}
        samplePosts={this.state.samplePosts}
        members={this.props.members}
        myCourses={this.props.myCourses}
        getActiveClassDetails={this.getActiveClassDetails}
        myClasses={this.props.myClasses}
        myGroups={this.props.myGroups}
        userName={this.props?.user}
        meetings={this.props.meetings}
        activeSectionState={this.props?.location?.state?.activeSection}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state?.profile?.name,
    //imageCover: "/Image/DashImage/class-cover.png",
    subjectName: state?.classes?.class?.name || "",
    subjectCode: state?.classes?.class?.code || "",
    grade: state?.classes?.class?.grade || "",
    // numOfPosts: state?.classes?.posts.length,
    class_id: state?.classes?.class?.id || "",
    subject: state?.classes?.class?.subject || "",
    routeType: "Class",
    imageCover:
      state?.classes?.class?.cover_image || "/Image/DashImage/class-cover.png",
    myClasses:
      state?.classes?.classes?.map((each_class) => {
        return { name: each_class.name, id: each_class.id, owner_name: each_class.class_owner_name };
      }) || [],
    myGroups:
      state?.groups?.myGroups?.map((each_group) => {
        return { name: each_group?.groups?.name, id: each_group?.groups?.id, group_type: each_group?.groups?.group_type, group_owner: each_group?.groups?.group_owner };
      }) || [],
    myCourses: [...state?.classes?.courses] || [],
    members: state?.classes?.members,
    meetings: state?.classes?.meetings || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getClassDetails: (subjectName) => dispatch(getClassDetails(subjectName)),
    getClasses: () => dispatch(getClasses()),
    getMyGroups: () => dispatch(getMyGroups()),
    getAllAssignments: (id, type) => dispatch(getAllAssignments(id, type)),
    getAllQuizzes: (id, type) => dispatch(getAllQuizzes(id, type)),
    clearCourses: () => dispatch(clearCourses()),
    getAllCourses: (classId, isPublic, isEnrolled, isFaculty, isFeed) => dispatch(getAllCourses(classId, isPublic, isEnrolled, isFaculty, isFeed)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Class))
);
